import { render } from "./DetalleHora.vue?vue&type=template&id=14e8ccf2"
import script from "./DetalleHora.vue?vue&type=script&lang=js"
export * from "./DetalleHora.vue?vue&type=script&lang=js"

import "./DetalleHora.vue?vue&type=style&index=0&id=14e8ccf2&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__